import { render, staticRenderFns } from "./InsurancesList.vue?vue&type=template&id=5fe8824a&"
import script from "./InsurancesList.vue?vue&type=script&lang=js&"
export * from "./InsurancesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports